import { API } from "../axios/API";

export const historicoService = {
  getHistorico
};

async function getHistorico(data) {
  try {
    const resp = await API.post("/historico/search", data);
    return resp?.data;
  } catch (err) {
    console.log(err);
    return err.response;
  }
}